import {
  Box,
  Card,
  CircularProgress,
  Grid,
  IconButton,
  Pagination,
  Switch,
  useTheme,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {
  CustomTableContainer,
  CustomTableHead,
  TableContentVendorFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
// import moment from "moment";
import empty from "../../../assets/illo.png";
import {
  ButtonLink,
  DisplayText,
} from "../../bankDetails/components/bankAccountsContent";
import PropTypes from "prop-types";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useDispatch, useSelector } from "react-redux";
import {
  getBusinessUnits,
  removeBusinessUnit,
  changeBusinessUnitStatus,
} from "../redux/businessUnitSlice";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Delete,
  PersonAdd,
  RemoveRedEye,
} from "@mui/icons-material";
// import { Company } from "../../../CONSTANTS";

const EmptyContainer = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <br />
    <img src={empty} alt="empty" />

    <DisplayText> There are no Business Units to display</DisplayText>
    <br />
    <ButtonLink to="/app/create-business-unit">+ Add Business Unit</ButtonLink>
    <br />

    <br />
  </Grid>
);

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };
  return (
    <>
      <Box sx={{ flexShrink: 0 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    </>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

function BusinessUnitTableContent({ search, clicked, setClicked }) {
  const [page, setPage] = React.useState(1);
  const [per_page, setPer_page] = React.useState(10);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [actionId, setActionId] = useState(null);

  const {
    businessUnitList,
    pagination,
    loading,
    deleteLoading,
    updateLoading,
  } = useSelector((state) => state.businessUnit);

  const dispatch = useDispatch();
  const fetchList = () => {
    const payload = {
      per_page,
      page,
      search,
    };
    dispatch(getBusinessUnits(payload));
    setClicked(false);
  };

  useEffect(() => {
    fetchList();
    // eslint-disable-next-line
  }, [page, rowsPerPage, per_page, clicked]);

  useEffect(() => {
    setPage(1);
  }, [per_page, clicked]);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDelete = (id) => {
    setActionId(id);
    dispatch(removeBusinessUnit({ id })).then((res) => {
      setActionId(null);
      if (res.payload?.success) {
        fetchList();
      }
    });
  };

  const handleStatusChange = (id, currentStatus) => {
    setActionId(id);
    const newStatus = !currentStatus;
    dispatch(changeBusinessUnitStatus({ id, isActive: newStatus })).then(
      (res) => {
        setActionId(null);
        if (res.payload?.success) {
          fetchList();
        }
      },
      () => setActionId(null),
    );
  };

  return (
    <CustomTableContainer component={Card}>
      <Table aria-label="simple table">
        <CustomTableHead>
          <TableRow>
            <TableCell>
              <TableHeaderFont>Name</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Description</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Status</TableHeaderFont>
            </TableCell>
            <TableCell>
              <TableHeaderFont>Action</TableHeaderFont>
            </TableCell>
          </TableRow>
        </CustomTableHead>
        <TableBody>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : businessUnitList?.length !== 0 ? (
            businessUnitList?.map((row) => {
              return (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    <TableContentVendorFont>
                      {row.businessUnitName !== null
                        ? row.businessUnitName
                        : "Not Applicable"}
                    </TableContentVendorFont>
                  </TableCell>
                  <TableCell>
                    {row.businessUnitDesc !== null
                      ? row.businessUnitDesc
                      : "Not Applicable"}
                  </TableCell>
                  <TableCell>
                    <Switch
                      checked={row.isActive || false}
                      disabled={updateLoading && actionId === row.id}
                      onChange={() => handleStatusChange(row.id, row.isActive)}
                      inputProps={{ "aria-label": "controlled" }}
                      sx={{
                        transform: "scale(0.60)",
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#2e7d32",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#2e7d32",
                          },
                        "& .MuiSwitch-switchBase": { color: "#d32f2f" },
                        "& .MuiSwitch-track": { backgroundColor: "#d32f2f" },
                      }}
                    />
                  </TableCell>

                  <TableCell>
                    <Box sx={{ display: "flex", gap: "10px" }}>
                      <Link to={`/app/business-unit/${row.id}`}>
                        <IconButton sx={{ p: 0.5 }}>
                          <PersonAdd
                            sx={{ fontSize: 18, color: "royalblue" }}
                          />
                        </IconButton>
                      </Link>
                      <Link to={`/app/business-unit/view/${row.id}`}>
                        <IconButton sx={{ p: 0.5 }}>
                          <RemoveRedEye
                            sx={{ fontSize: 18, color: "royalblue" }}
                          />
                        </IconButton>
                      </Link>
                      <IconButton
                        onClick={() => handleDelete(row.id)}
                        disabled={deleteLoading && actionId === row.id}
                        sx={{ p: 0.5 }}
                      >
                        {deleteLoading && actionId === row.id ? (
                          <CircularProgress size={18} />
                        ) : (
                          <Delete sx={{ fontSize: 18, color: "#d32f2f" }} />
                        )}
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={4}>
                <CustomTableContainer>
                  <EmptyContainer />
                </CustomTableContainer>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>

      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        sx={{ height: "10vh", borderTop: "1px solid lightgray", px: 3 }}
      >
        <Grid item sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <span>Rows per page:</span>
          <select
            value={per_page}
            onChange={(e) => {
              setPer_page(e.target.value);
              setPage(1);
            }}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </Grid>

        <Grid item>
          <Pagination
            color="primary"
            variant="text"
            onChange={(_, newValue) => setPage(newValue)}
            count={pagination?.total_page}
            page={page}
            shape="rounded"
            showFirstButton
            showLastButton
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Grid>
      </Grid>
    </CustomTableContainer>
  );
}

export default BusinessUnitTableContent;
